import { collection, getDocs, query, where, updateDoc, doc } from 'firebase/firestore';
import { db } from '../services/firebase';

/**
 * Utility function to approve a school registration by email
 * This should be run from the browser console for development purposes
 */
export async function approveSchoolByEmail(adminEmail: string): Promise<void> {
  try {
    console.log('Looking for admin user with email:', adminEmail);

    // Find admin user by email
    const adminUsersSnapshot = await getDocs(
      query(collection(db, 'adminUsers'), where('email', '==', adminEmail))
    );

    if (adminUsersSnapshot.empty) {
      throw new Error(`No admin user found with email: ${adminEmail}`);
    }

    const adminUserDoc = adminUsersSnapshot.docs[0];
    const adminUserData = adminUserDoc.data();
    const schoolId = adminUserData.schoolId;

    console.log('Found admin user, school ID:', schoolId);

    // Update school registration status
    await updateDoc(doc(db, 'schoolRegistrations', schoolId), {
      status: 'Approved',
      approvedBy: 'system',
      approvedAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    });

    console.log('School registration approved');

    // Activate admin user
    await updateDoc(adminUserDoc.ref, {
      isActive: true,
      updatedAt: new Date().toISOString()
    });

    console.log('Admin user activated');
    console.log('School approved successfully! Please refresh the page.');

  } catch (error) {
    console.error('Error approving school:', error);
    throw error;
  }
}

// Make it available globally for console access
if (typeof window !== 'undefined') {
  (window as any).approveSchoolByEmail = approveSchoolByEmail;
}
